function fn_show_more(button,block){
    $(button).on('click', function (e) {
        e.preventDefault();
        console.log('click');
        $(this).parents(block).next().slideToggle(700);
    })
}

function fn_show_more_second(button,block,parent){
    $(button).on('click', function (e) {
        e.preventDefault();
        console.log('click');
        $(this).parents(parent).find(block).slideToggle(700);
    })
}